import { IEventModify } from 'interface/link/event';
import { handleGet, handlePost } from './common';
import { IDateToken } from 'interface/link/dateToken';
import { NextStepLinkClass } from 'interface/link/nextStep';
import { NewAccountLinkClass } from 'interface/link/newAccount';

class ModifyLinkService {
  async getLinkInfo(linkId: string): Promise<NewAccountLinkClass> {
    return await handleGet(
      '/modify-link',
      { linkId },
      { 'x-api-access-token': import.meta.env.VITE_API_KEY },
    );
  }

  async getNextStep(linkId: string): Promise<NextStepLinkClass> {
    return await handleGet(
      '/modify-link/next-step',
      { linkId },
      { 'x-api-access-token': import.meta.env.VITE_API_KEY },
    );
  }

  async submitDateTokenInfo(data: IDateToken) {
    return await handlePost(
      '/modify-link/date-token',
      { ...data },
      { 'x-api-access-token': import.meta.env.VITE_API_KEY },
    );
  }

  async submitEventInfo(data: IEventModify) {
    return await handlePost(
      '/modify-link/event',
      { ...data },
      { 'x-api-access-token': import.meta.env.VITE_API_KEY },
    );
  }
}

export default new ModifyLinkService();
